/**
 * Width of the fixed left sidebar. Used both by the sidebar itself (w-*)
 * and the main content wrapper (ml-*) so they stay in sync.
 */
export const SIDEBAR_WIDTH_CLASS = 'w-64';
export const SIDEBAR_OFFSET_CLASS = 'ml-64';
